import type { ReactElement } from 'react'
import { createRoot } from 'react-dom/client'

export function bootstrapRoot(app: ReactElement): void {
  const rootEl = document.getElementById('root')
  if (rootEl) {
    createRoot(rootEl).render(app)
  }
}
